<i18n>
{
  "de": {
    "noOfferpublished": "hat noch kein Angebot veröffentlicht.",
    "pageTitle": "Mitgliedschaften"
  },
  "en": {
    "noOfferpublished": "has not published an offer yet.",
    "pageTitle": "Memberships"
  }
}
</i18n>
<template>
  <section class="section mt-20">
    <div class="container">
      <div class="columns">
        <div
          class="column"
          :class="isMobileView ? 'is-hidden' : 'is-one-quarter'"
        >
          <sidenav />
        </div>
        <div
          v-if="artist.rewards.length"
          class="column"
        >
          <profile-reward
            v-for="(reward, index) in sortedRewards"
            :key="reward._id"
            :reward="reward"
            :highlight="highlight"
            :listview="true"
            :index="index"
          />
        </div>
        <div
          v-else
          class="column"
        >
          <div class="box">
            <h2>{{ artist.nickname }} {{ $t('noOfferpublished') }}</h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import sidenav from '~/components/sidenav'
import profileReward from '~/components/profile-reward'
import artistPageHead from '~/mixins/artistPageHead'

export default {
  mixins: [artistPageHead],

  components: {
    profileReward,
    sidenav
  },

  data() {
    return {
      amount: -1,
      scrollAnimation: false
    }
  },

  async asyncData({ params, app, req }) {
    if (!params.amount) {
      params.amount = -1
    }
    return params
  },

  computed: {
    sortedRewards() {
      if (this.artist && this.artist.rewards) {
        return this.artist.rewards.slice().sort((a, b) => {
          if (a.amount > b.amount) {
            return 1
          }
          if (a.amount < b.amount) {
            return -1
          }
          return 0
        })
      }
      return []
    },
    ...mapState(['artist']),

    highlight() { return this.amount }
  },

  mounted() {
    if (this.scrollAnimation && this.amount) {
      const selectedReward = this.sortedRewards.filter(r => r.amount === this.amount)[0]
      if (selectedReward) {
        this.$scrollTo(document.querySelector(`#reward_${selectedReward._id}`))
      }
    }
  }
}
</script>

<style lang="scss">
@import 'assets/sass/_variables';

h2 {
  color: var(--secondary-color);
}
</style>
